import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Impact2 from "./Impact2";
import Testimonials from "./Testimonials";
import reviews from "./data";


import syep2024 from "../../Assets/syepMain.png";

import syep2 from "../../Assets/syep_2025_2.jpg";
import syep2025 from "../../Assets/syep_2025.jpeg";
import gradSYEP2024 from "../../Assets/gradSYEP.png";
import gradSYEP2025 from "../../Assets/SYEP_2025_Grad.png";
import syep3 from "../../Assets/syep_2025_3.jpg";



// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  { src: syep2, alt: "syep" },
  { src: syep3, alt: "syep" },
  { src: syep2024, alt: "syep" },
  { src: gradSYEP2024, alt: "syep" },  
  { src: syep2025, alt: "syep" }, 
   { src: gradSYEP2025, alt: "syep" }, 
  



  // Add more images as needed

  ];
console.log(sliderImages)


function Impact() {

  const navigate = useNavigate(); // Initialize navigate
    
  
  const handleClick = () => {
    navigate("/registration#internship-section"); // This will navigate to the "/another-page" route
  };

  


  // Settings for the Slick slider
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time between slides in ms
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid"
                    style={{ objectFit: "cover", height: "60%", width: "100%" }}
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>

     

       <Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  Apply Now
</Button>

      
      
          <Impact2 />

                                        
                    <div className="testimonials">
          <Testimonials reviews={reviews}/>              
          </div>
             

          
           
    </section>
  );
}

export default Impact;
